"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _RadioButton = _interopRequireDefault(require("./RadioButton"));
var _CoreInput = require("../../utilities/CoreInput");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const RadioButtonGroup = /*#__PURE__*/(0, _react.forwardRef)((props, ref) => {
  const {
    options,
    layout,
    onChange,
    name,
    defaultValue
  } = props;
  const [selected, setSelected] = (0, _react.useState)();
  (0, _react.useEffect)(() => {
    const selectedOption = options && options.length > 0 ? options.find(item => typeof (defaultValue === null || defaultValue === void 0 ? void 0 : defaultValue.value) !== 'undefined' ? item.value === defaultValue.value : item.value === defaultValue) : null;
    if (selectedOption) {
      onChange(selectedOption);
      setSelected(selectedOption);
    }
  }, [options, defaultValue]);
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, options.map(option => {
    const checked = typeof (selected === null || selected === void 0 ? void 0 : selected.value) !== 'undefined' ? option.value === selected.value : option.value === selected;
    return /*#__PURE__*/_react.default.createElement(_RadioButton.default, {
      ref: ref,
      key: `radiobuttongroup_${name}_${option.value}_${checked}`,
      name: name,
      label: option.label,
      value: option.value,
      anchor: option.anchor,
      checked: typeof (selected === null || selected === void 0 ? void 0 : selected.value) !== 'undefined' ? option.value === selected.value : option.value === selected,
      layout: layout,
      disabled: option.disabled,
      invalid: option.invalid,
      onChange: () => {
        onChange(option);
        setSelected(option);
      }
    });
  }));
});
RadioButtonGroup.displayName = 'RadioButtonGroup';
RadioButtonGroup.propTypes = {
  options: _propTypes.default.arrayOf(_propTypes.default.shape({
    label: _propTypes.default.string,
    value: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number, _propTypes.default.bool]),
    disabled: _propTypes.default.bool,
    invalid: _propTypes.default.bool
  })),
  layout: _propTypes.default.string,
  onChange: _propTypes.default.func,
  name: _propTypes.default.string,
  defaultValue: _propTypes.default.oneOfType([_propTypes.default.shape({
    label: _propTypes.default.string,
    value: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number, _propTypes.default.bool]),
    disabled: _propTypes.default.bool,
    invalid: _propTypes.default.bool
  }), _propTypes.default.string])
};
RadioButtonGroup.defaultProps = {
  onChange: () => {}
};
var _default = exports.default = (0, _CoreInput.withFieldControl)(RadioButtonGroup);
//# sourceMappingURL=RadioButtonGroup.js.map